import { useState, useEffect } from "react";
import { directoryApi } from "@/lib/api";
import { UserCircle, MagnifyingGlass } from "@phosphor-icons/react";

export default function MemberDirectory() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    directoryApi.members().then(({ data }) => { setMembers(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtered = search.trim()
    ? members.filter(m => m.name.toLowerCase().includes(search.toLowerCase()) || m.memberNumber?.toLowerCase().includes(search.toLowerCase()))
    : members;

  if (loading) return <div className="space-y-3">{[1,2,3].map(i => <div key={i} className="h-16 bg-muted rounded-xl animate-pulse" />)}</div>;

  return (
    <div className="space-y-4" data-testid="member-directory">
      <h2 className="font-heading text-2xl font-semibold tracking-tight">Member Directory</h2>
      <div className="relative">
        <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          data-testid="directory-search"
          className="w-full pl-10 pr-3 py-2.5 text-sm bg-card border border-input rounded-xl focus:outline-none focus:ring-2 focus:ring-ring"
          placeholder="Search by name or member number..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="bg-card border border-border rounded-xl overflow-hidden divide-y divide-border">
        {filtered.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground text-sm">No members found</div>
        ) : filtered.map((m) => (
          <div key={m.id} className="px-5 py-3 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <UserCircle className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">{m.name}</p>
              <p className="text-xs text-muted-foreground">{m.clanName} &middot; {m.familyName}</p>
            </div>
            <div className="text-right shrink-0">
              <span className="font-mono text-xs bg-secondary text-secondary-foreground px-2 py-0.5 rounded">{m.memberNumber}</span>
              {/* Phone numbers are NEVER shown in the member-view directory.
                  Super-admins still see member phones via Admin view → Members. */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
